<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('quartz.scheduleJob.add')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm">
              <span>{{$t('tlt.administration')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm/systemParameters">
              <span>{{$t('tlt.systemParameters')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/adm/systemParameters/edit">
              <span>{{$t('tlt.systemParameters.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('quartzSchedule')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" v-on:click="MMFSave('quartzSchedule')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('quartz.scheduleJob.jobName')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="jobName"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('jobName') }"
                  v-model="jobName"
                  type="text"
                />
                <span
                  v-show="errors.has('jobName')"
                  class="lbl-obg"
                >{{ errors.first('jobName') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('quartz.scheduleJob.module')}}:
                </label>
                <!-- <input
                  v-validate="'required'"
                  name="module"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('module') }"
                  v-model="module"
                  type="text"
                  @blur="changeModule(module)"
                /> -->
                <select class="form-control form-control-sm" v-model="module" @change="changeModule(module)">
                  <option value='admin' selected="selected">admin</option>
                  <option value='master'>master</option>
                  <option value='production'>production</option>
                  <!-- <option value='inventory'>inventory</option> -->
                  <option value='report'>report</option>
                  <option value='protocol'>protocol</option>
                </select>
                <span
                  v-show="errors.has('module')"
                  class="lbl-obg"
                >{{ errors.first('module') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('quartz.scheduleJob.methodReference')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="methodReference"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('methodReference') }"
                  v-model="methodReference"
                  type="text"
                />
                <span
                  v-show="errors.has('methodReference')"
                  class="lbl-obg"
                >{{ errors.first('methodReference') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('quartz.scheduleJob.cronExpression')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="cronExpression"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('cronExpression') }"
                  v-model="cronExpression"
                  type="text"
                />
                <span
                  v-show="errors.has('cronExpression')"
                  class="lbl-obg"
                >{{ errors.first('cronExpression') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <!-- <span class="lbl-obg">*</span> -->
                  {{$t('quartz.scheduleJob.param')}}:
                </label>
                <input
                  name="params"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('params') }"
                  v-model="params"
                  type="text"
                />
                <span
                  v-show="errors.has('params')"
                  class="lbl-obg"
                >{{ errors.first('params') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('quartz.scheduleJob.status')}}:
                </label>
                <select name="status" class="form-control form-control-sm" v-model="status">
                  <option value=1 selected="selected">{{ $t("btn.basic.send") }}</option>
                  <option value=0>{{ $t("btn.basic.quartzStop") }}</option>
                </select>
                <span
                  v-show="errors.has('status')"
                  class="lbl-obg"
                >{{ errors.first('status') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('quartz.scheduleJob.description')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="description"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('description') }"
                  v-model="description"
                  type="text"
                />
                <span
                  v-show="errors.has('description')"
                  class="lbl-obg"
                >{{ errors.first('description') }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions } from "vuex";
import { fields }  from "@/model/quartz/QuartzSchedule";

const { mapFields } = createHelpers({
  getterType: 'quartzSchedule/getField',
  mutationType: 'quartzSchedule/updateField',
})

export default {
  name: "quartzScheduleEdit",
  data() {
    return {
      
    };
  },
      
  computed: {
    ...mapFields(fields),
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"]),
    changeModule(value) {
      this.$store.commit("quartzSchedule/setUrlFromModule", value)
    }
  }
};
</script>